import React, { Component, } from 'react'

import {CCLeagueItem, CCIcon, colors} from './../../cc-imports'

import PropTypes from 'prop-types';
import './../../styles/css/components/CCLeaguesGroup/cc-leagues-group.css'
import CCErrorBoundary from "../CCErrorBoundary/CCErrorBoundary";

class CCLeaguesGroup extends Component {

    static propTypes = {
        leaguePressed : PropTypes.func,
        entryCountPressed : PropTypes.func,

        infoPressed : PropTypes.func,
        sponsorBannerPressed : PropTypes.func,
        currUser : PropTypes.object,
        getHelpDetails : PropTypes.func,

    }

    static defaultProps = {
        leaguePressed : ()=>{},
        entryCountPressed : ()=>{},

        infoPressed : ()=>{},
        sponsorBannerPressed : ()=>{},
        currUser:{},
        getHelpDetails : ()=>{}
    }

    constructor(props) {
        super(props)
        this.state = {}

        this._onBannerPressed=this._onBannerPressed.bind(this);
        this._onLeaguePressed=this._onLeaguePressed.bind(this);
        this._onEntryCountPressed=this._onEntryCountPressed.bind(this);
        this._onInfoPressed=this._onInfoPressed.bind(this);
        this._getHelpDetails=this._getHelpDetails.bind(this);
    }

    _onLeaguePressed(league){
        this.props.leaguePressed(league);
    }

    _onEntryCountPressed(league){
        this.props.entryCountPressed(league);
    }

    _onInfoPressed (sponsor) {
        this.props.sponsorBannerPressed(sponsor);
        console.log(this.props.sponsorBannerPressed(sponsor),'ffffffffffff')

    }

    _onBannerPressed(sponsor) {
        this.props.infoPressed(sponsor);
        console.log(this.props.infoPressed(sponsor),'aaaaaaaaaaaaa')

    }

    _getPromoDetails(sponsor) {
        //return {}
        const currUser = this.props.currUser;
        if(currUser){
            return sponsor && sponsor.promoDetails && (sponsor.promoDetails[currUser.country]||sponsor.promoDetails['ALL']);
        }
        else {
            return;
        }
    }

     _getHelpDetails(league) {
        return this.props.getHelpDetails(league);
    }


    render() {
        const {leagueGroup, currUser} =this.props;
        const {sponsor, matchCompleted} = leagueGroup;


        if(sponsor==undefined){
            return(

                <div className="flex-container cc-leagues-group" style={{...this.props.style}}>
                    {
                        leagueGroup.leagues && leagueGroup.leagues.map((league, index)=>{
                            return (<CCLeagueItem onEntriesPress={this._onEntryCountPressed} onPress={this._onLeaguePressed}  league={league} key={index} style={{marginTop:10, marginRight:20, marginLeft:20}} />)
                        })
                    }
                </div>
            )
        }

        else {
            return (
                <CCErrorBoundary>

                <div className="flex-container cc-leagues-group" style={{backgroundColor : matchCompleted ? colors.theme2.bg_color11 :colors.theme2.bg_color7}}>
                    {
                        sponsor &&
                        <div className="flex-container sponsor-container">
                            <div className="flex-container" style={{flex:1}}>
                                {
                                    (sponsor.theme && sponsor.theme.sGrpBannerImg) &&
                                    <div className={"btn"} disabled={currUser==undefined || this._getPromoDetails(sponsor)==undefined}  style={{flex:1, marginRight:5}} onPress={()=>{this._onBannerPressed(leagueGroup.sponsor)}}>
                                        <img className={'sponsor-img'} src={sponsor.theme.sGrpBannerImg}></img>
                                    </div>
                                }
                            </div>
                            {
                                this._getPromoDetails(sponsor) &&
                                <div className="flex-container helper-icon">
                                    <CCIcon className={"btn cc-icon-m cc-info-icon"}  onPress={()=>{this._onInfoPressed(leagueGroup.sponsor)}}
                                            type={"info"}
                                    />
                                </div>
                            }
                        </div>
                    }
                    {
                        leagueGroup.leagues && leagueGroup.leagues.map((league, index)=> {
                            return (<CCLeagueItem  helpDetails={this._getHelpDetails(league)} onEntriesPress={this._onEntryCountPressed} onPress={this._onLeaguePressed}  style={{margin:10}} league={league} key={index} />)
                        })
                    }

                </div>
                </CCErrorBoundary>
            )
        }


    }
}

export default CCLeaguesGroup



// WEBPACK FOOTER //
// ./src/app/components/CCLeaguesGroup/CCLeaguesGroup.js